/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorBreakingNews from 'base/components/labrador/BreakingNews';

export const DynamicLabradorBreakingNews: typeof LabradorBreakingNews = (props) => {
    return <ErrorBoundary><LabradorBreakingNews {...props} /></ErrorBoundary>;
}
export type DynamicLabradorBreakingNewsProps = PropsFromComponent<typeof LabradorBreakingNews>;
